import { memo } from 'react';
import { motion } from 'framer-motion';
import { DROPS_TAB_LIST, DROPS_FILTERS_LIST, DropsFilter, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { useDropEventListFiltersContext } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { useTabAvailableFilters } from 'root/src/client/v2/_pages/drops/hooks/useTabAvailableFilters';
import { useDropsTabCounts } from 'root/src/client/v2/_pages/drops/redesign/useDropsTabCounts';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
import { cn } from 'root/src/client/v2/common/helpers/cn';
export const DropsTabsBar = memo(() => {
    const { tab, onTabChange } = useDropEventListFiltersContext();
    const counts = useDropsTabCounts();
    // Hide tabs that have loaded with 0 drops (matches the legacy `getAvailableDropsTabs`), but always
    // keep the active tab and any tab whose count is still loading (undefined), so the bar never ends up
    // with no active tab.
    const visibleTabs = DROPS_TAB_LIST.filter(({ value }) => value === tab || counts[value] !== 0);
    return (<div data-onboarding="drops-tabs" className="flex w-fit items-center gap-0.5 rounded-lg bg-white/[0.04] p-1">
			{visibleTabs.map(({ title, value }) => {
            const active = tab === value;
            const count = counts[value];
            return (<button key={value} type="button" onClick={() => onTabChange(value)} className={cn('relative rounded-lg px-4 py-2 text-sm font-medium transition-colors', active ? 'text-white' : 'text-muted-foreground hover:text-foreground')}>
						{active && (<motion.span layoutId="dropsTabIndicator" className="absolute inset-0 rounded-lg bg-primary" transition={{ type: 'spring', bounce: 0.2, duration: 0.4 }}/>)}
						<span className="relative z-10 flex items-center gap-1.5">
							{title}
							{typeof count === 'number' && (<span className={cn('rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none tabular-nums', active ? 'bg-white/20 text-white' : 'bg-white/[0.08] text-muted-foreground')}>
									{count}
								</span>)}
						</span>
					</button>);
        })}
		</div>);
});
export const DropsFilters = memo(() => {
    const { isLoading, defaultFilter, availableFilters } = useTabAvailableFilters();
    const { filter, onFilterChange } = useDropEventListFiltersContext();
    const list = DROPS_FILTERS_LIST.filter(option => availableFilters.includes(option.value));
    if (isLoading) {
        return (<div className="flex flex-wrap gap-2">
				<Skeleton className="h-7 w-12 rounded-full"/>
				<Skeleton className="h-7 w-24 rounded-full"/>
				<Skeleton className="h-7 w-16 rounded-full"/>
			</div>);
    }
    if (!list.length) {
        return null;
    }
    return (<div data-onboarding="drops-filters" className="flex flex-wrap gap-2">
			{list.map((option) => {
            const active = filter === DropsFilter.Default
                ? option.value === defaultFilter
                : option.value === filter;
            return (<button key={option.value} type="button" onClick={() => onFilterChange(option.value)} className={cn('relative rounded-full px-3 py-1 text-xs font-medium transition-colors', active ? 'text-white' : 'bg-white/[0.04] text-muted-foreground hover:bg-secondary hover:text-foreground')}>
						{active && (<motion.span layoutId="dropsFilterIndicator" className="absolute inset-0 rounded-full bg-primary" transition={{ type: 'spring', bounce: 0.2, duration: 0.4 }}/>)}
						<span className="relative z-10">{option.title}</span>
					</button>);
        })}
		</div>);
});
